import productHtmlTemplate from './center/product.html?raw'
import startTemplate from './center/start.html?raw'
import updates from './center/updates.html?raw'
import biReport from './center/biReport.html?raw'
import workshopAdmin from './center/workshopAdmin.html?raw'
import distributorAdmin from './center/distributorAdmin.html?raw'
import fleetCareAdmin from './center/fleetCareAdmin.html?raw'
import fleetsOverview from './center/fleetsOverview.html?raw'
import headerTemplate from './header/header.html?raw'
import leftPanelTemplate from './leftPanel/leftPanel.html?raw'
import plannerFullScreen from './center/plannerFullScreen.html?raw'
import productTabsTemplate from './center/productTabs.html?raw'
import customerVehicles from './center/customerVehicles.html?raw'
import fleetVehicles from './center/fleetVehicles.html?raw'
import workOrderPreview from './center/workOrderPreview.html?raw'

import headless from './headless/headless.html?raw'

export default [
  productHtmlTemplate,
  startTemplate,
  updates,
  biReport,
  workshopAdmin,
  distributorAdmin,
  fleetCareAdmin,
  fleetsOverview,
  headerTemplate,
  leftPanelTemplate,
  plannerFullScreen,
  productTabsTemplate,
  customerVehicles,
  fleetVehicles,
  headless,
  workOrderPreview
]
